import React, { Component } from "react";
import { languages } from "../../constants/languages";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton";
import SwapIcon from "@material-ui/icons/SwapHoriz";
import { getResultSpotName } from "../../util/GetResultSpotName";
import CheckIcon from "@material-ui/icons/CheckCircle";
import HelpIcon from "@material-ui/icons/HelpOutline";
import { Tooltip } from "@material-ui/core";

class TeamsNotDivided extends Component {
  render() {
    let hideBye = false;
    let hideNoShow = false;
    let poule =
      this.props.poulesByKey[
        this.props.selectedTeam["poule" + this.props.fase]
      ] || {};
    // if (
    //   (this.props.selectedTeam["numInPoule" + this.props.fase] === 1 &&
    //     poule["status0"] === "bye") ||
    //   (this.props.selectedTeam["numInPoule" + this.props.fase] === 0 &&
    //     poule["status1"] === "bye")
    // ) {
    //   hideBye = true;
    // }
    if (this.props.fase !== 0) {
      hideNoShow = true;
      // hideBye = true;
    }
    if (poule.bracket) {
      let bracket = this.props.bracketsByKey[poule.bracket] || {};
      if (bracket.size === 2) {
        hideBye = true;
      }
    }
    return (
      <Menu
        id="lock-menu"
        anchorEl={this.props.anchorEl}
        open={Boolean(this.props.anchorEl)}
        onClose={this.props.handleClose}
        PaperProps={{
          style: {
            maxHeight: 30 * 6,
            minWidth: 180,
          },
        }}
      >
        {(!this.props.selectedTeam.empty || this.props.selectedTeam.status) && (
          <MenuItem
            style={{
              height: 30,
              padding: "0 10px",
              fontStyle: "italic",
            }}
            onClick={(event) => this.props.handleMenuItemClick(event, null)}
          >
            {languages.structure.none}
          </MenuItem>
        )}
        {this.props.selectedTeam.isInBracket &&
          this.props.numTeams > 0 &&
          this.props.selectedTeam.status !== "bye" &&
          !hideBye && (
            <MenuItem
              style={{
                height: 30,
                padding: "0 10px",
                fontStyle: "italic",
              }}
              onClick={(event) => this.props.handleMenuItemClick(event, "bye")}
            >
              {languages.structure.bye}
              <ListItemSecondaryAction>
                <Tooltip
                  title={languages.formatString(
                    languages.structure.byeText,
                    this.props.tournament.individualPlayers
                      ? languages.teams.playerLow
                      : languages.results.teamLow
                  )}
                  placement="top"
                >
                  <span>
                    <IconButton
                      disabled
                      edge="end"
                      style={{ width: 30, height: 30 }}
                    >
                      <HelpIcon
                        style={{
                          height: 17,
                          position: "absolute",
                          top: 7,
                        }}
                      />
                    </IconButton>
                  </span>
                </Tooltip>
              </ListItemSecondaryAction>
            </MenuItem>
          )}
        {!this.props.selectedTeam.isInBracket &&
          this.props.numTeams > 0 &&
          !this.props.selectedTeam.empty &&
          !hideNoShow && (
            <MenuItem
              style={{
                height: 30,
                padding: "0 10px",
                fontStyle: "italic",
              }}
              onClick={(event) =>
                this.props.handleMenuItemClick(event, "noShow")
              }
            >
              {languages.structure.noShow}
              <ListItemSecondaryAction>
                <Tooltip
                  title={languages.formatString(
                    languages.structure.noShowText,
                    this.props.tournament.individualPlayers
                      ? languages.teams.playerLow
                      : languages.results.teamLow
                  )}
                  placement="top"
                >
                  <span>
                    <IconButton
                      disabled
                      edge="end"
                      style={{ width: 30, height: 30 }}
                    >
                      <HelpIcon
                        style={{
                          height: 17,
                          position: "absolute",
                          top: 7,
                        }}
                      />
                    </IconButton>
                  </span>
                </Tooltip>
              </ListItemSecondaryAction>
            </MenuItem>
          )}

        {(!this.props.selectedTeam.empty || this.props.selectedTeam.status) && (
          <MenuItem
            style={{
              height: 30,
              padding: "0 10px",
              fontWeight: "500",
            }}
            selected={true}
            disabled={true}
          >
            {this.props.selectedTeam.gamertag || this.props.selectedTeam.name}
          </MenuItem>
        )}
        {this.props.selectedTeam.empty && this.props.teams.length === 0 && (
          <MenuItem
            style={{
              height: 75,
              padding: "0 10px",
              width: 220,
              whiteSpace: "normal",
            }}
            disabled={true}
          >
            {languages.formatString(
              languages.structure.allTeamsDivided,
              this.props.tournament.individualPlayers
                ? languages.teams.playersLow
                : languages.tournament.teamsLow
            )}
            {(this.props.fase === undefined || this.props.fase === 0) &&
              " " +
                languages.formatString(
                  languages.structure.addTeamsOnTeamPage,
                  this.props.tournament.individualPlayers
                    ? languages.teams.playersLow
                    : languages.tournament.teamsLow
                )}
          </MenuItem>
        )}
        {this.props.teams.map((team, index) => {
          let name = team.gamertag || team.name;
          if (team.fase !== undefined) {
            name = getResultSpotName(
              team,
              this.props.resultSpotsAll,
              this.props.poulesByKey,
              this.props.divisionsObject
            );
          }
          return (
            <MenuItem
              style={{
                height: 30,
                padding: "0 40px 0 10px",
              }}
              key={team.id}
              onClick={(event) => this.props.handleMenuItemClick(event, team)}
            >
              {name}
              {team.fase !== undefined && !team.belongsToBracket && (
                <ListItemSecondaryAction>
                  <IconButton
                    edge="end"
                    style={{ width: 30, height: 30 }}
                    onClick={(e) => {
                      this.props.toggleResultSpotType(e, team.fase, team.rank);
                    }}
                  >
                    <SwapIcon
                      style={{ height: 20, position: "absolute", top: 5 }}
                    />
                  </IconButton>
                </ListItemSecondaryAction>
              )}
              {team.present && (
                <ListItemSecondaryAction>
                  <IconButton
                    disabled
                    edge="end"
                    style={{ width: 30, height: 30 }}
                  >
                    <CheckIcon
                      style={{
                        height: 17,
                        position: "absolute",
                        top: 7,
                        color: "green",
                      }}
                    />
                  </IconButton>
                </ListItemSecondaryAction>
              )}
            </MenuItem>
          );
        })}
      </Menu>
    );
  }
}

export default TeamsNotDivided;
